import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import apiV2 from '../utils/apiV2';

// Slim QuickBooks status strip for the Expenses / Revenue tabs.
export const QuickBooksSyncHint = ({ variant, onNavigate }) => {
  const [status, setStatus] = useState(null);
  const orgId = localStorage.getItem('organizationId');

  useEffect(() => {
    if (!orgId) return;
    apiV2.get(`/organizations/${orgId}/quickbooks/status`)
      .then((r) => setStatus(r.data))
      .catch(() => setStatus(null));
  }, [orgId]);

  if (!status || !status.configured) return null;

  const goToIntegrations = (e) => {
    e.preventDefault();
    if (onNavigate) onNavigate('conversions');
    else window.location.href = '/admin?tab=conversions';
  };

  const enabled = variant === 'expenses' ? status.syncExpenses : status.syncRevenue;
  const what = variant === 'expenses'
    ? 'Expenses post to QuickBooks as Purchases'
    : 'Paid bookings post to QuickBooks as daily Sales Receipts';
  const whatShort = variant === 'expenses'
    ? 'expenses are posting as Purchases'
    : 'paid bookings are posting as daily Sales Receipts';

  if (status.connected && enabled) {
    return (
      <div className="flex items-center gap-2 text-xs text-gray-500" data-testid={`qbo-hint-${variant}`}>
        <span className="w-1.5 h-1.5 rounded-full bg-green-500 shrink-0" />
        <span>
          Synced to QuickBooks{status.companyName ? ` · ${status.companyName}` : ''} — {whatShort}
        </span>
        <a href="/admin?tab=conversions" onClick={goToIntegrations} className="text-blue-600 hover:text-blue-700 font-medium shrink-0" data-testid={`qbo-hint-${variant}-manage`}>
          Manage
        </a>
      </div>
    );
  }

  if (status.connected && !enabled) return null;

  return (
    <div className="flex items-center gap-2 text-xs text-gray-500" data-testid={`qbo-hint-${variant}`}>
      <span className="w-4 h-4 shrink-0" aria-hidden="true"><img src="/images/integrations/quickbooks-mark.png" alt="" className="w-4 h-4" /></span>
      <span>{what} once you link your books.</span>
      <a href="/admin?tab=conversions" onClick={goToIntegrations} className="inline-flex items-center gap-0.5 text-blue-600 hover:text-blue-700 font-medium shrink-0" data-testid={`qbo-hint-${variant}-connect`}>
        Connect QuickBooks <ArrowRight className="w-3 h-3" />
      </a>
    </div>
  );
};

export default QuickBooksSyncHint;
